<template>
  <div class="half-width">
    <div
      class="flex flex-1 flex-col items-start justify-end"
      :class="isActive ? 'bg-primary text-white': 'bg-white text-primary'"
    >
      <div class="flex pl-2 w-full gap-2 relative items-center">
        <div
          class="cursor-pointer bg-pink-lighter px-4 py-0.5 font-bold rounded-xl text-sm"
        >
          {{ customer.beneficiaries.length }} ayant-droit{{ customer.beneficiaries.length > 1 ? 's' : '' }}
        </div>
        <div
          class="bg-pink-lighter cursor-pointer px-4 py-0.5 font-bold rounded-xl text-sm"
        >
          {{ customer.pets?.length ?? 0 }} {{ customer.pets.length > 1 ? 'animaux' : 'animal' }}
        </div>
        <button
          class="items-center flex justify-center w-6 h-6 relative -left-4"
          @click="$router.push({ name: 'customer.pet.create'})"
        >
          <Add :size="18" :color="isActive ? 'white' : 'primary'" />
        </button>
      </div>
      <div class="flex flex-row w-full px-3 pb-2">
        <div class="flex flex-1 flex-row items-center py-1 overflow-x-auto w-64 min-h-12">
          <router-link
            v-for="(beneficiary, index) in customer.beneficiaries"
            :key="'ben' + index"
            :to="{ name: 'customer.beneficiary', params: { id: beneficiary.id } }"
            active-class="font-semibold"
          >
            <CustomerHeaderBeneficiary :beneficiary="beneficiary" />
          </router-link>
          <router-link
            v-for="(pet, index) in customer.pets"
            :key="'pet'+ index"
            :to="{ name: 'customer.pet', params: { id: pet.id } }"
            active-class="font-semibold"
          >
            <CustomerHeaderPet :pet="pet" />
          </router-link>
          <div
            v-if="!customer.beneficiaries.length && !customer.pets.length"
            class="text-sm text-gray-500 italic"
          >
            Aucun ayant-droits ou animal.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import CustomerHeaderBeneficiary from '@/customer/components/customer-header/CustomerHeaderBeneficiary.vue';
import Customer from "@/customer/interfaces/Customer";
import {useRoute} from "vue-router";
import CustomerHeaderPet from "@/customer/components/customer-header/CustomerHeaderPet.vue";
import Add from "@/core/components/icons/Add.vue";

const route = useRoute();

defineProps<{
    customer: Customer
}>();

/** Check if the current route is the beneficiary route */
const isActive = computed(() => {
    return route.name === 'customer.beneficiary' || route.name === 'customer.pet' || route.name == 'customer.pet.create';
});
</script>

<style scoped>
.half-width {
    max-width: 50%;
    width: 50%;
    display: flex;
    flex: 1 0 0;
}

.scroll-container {
    @apply flex flex-row flex-grow flex-row border-red-700 border-2;
    overflow-x: scroll;
}
</style>
